import {
  DarwinFlex,
  DMenuProps,
  DTableProps,
  renderUserCell,
  renderDateCell,
  ActionsDropdown,
  CombinedText,
  ACTIONS_COL_WIDTH,
} from '@darwin-ui';
import { Role } from 'types/rolesTypes';
import Icon from 'components/darwin-ui/Icon';
import { TFunction } from 'i18next';
import { ColumnAction } from '.';

export const getRolesColumns = (
  t: TFunction,
  actions: ColumnAction[],
  searchQuery: string
) => {
  const menuItems = (role: Role): DMenuProps['items'] =>
    actions
      .filter(action => {
        return (
          role.createdBy !== null ||
          action.key === 'view' ||
          (role.name === 'END_USER' && action.key === 'duplicate')
        );
      })
      .map(action => ({
        key: action.key,
        label: (
          <DarwinFlex
            gap={8}
            align="center"
            onClick={() => {
              action?.onClick?.(role);
            }}
          >
            <Icon name={action.name} size="sm" color="inherit" />
            {action.label}
          </DarwinFlex>
        ),
      }));

  const renderUserCol = (user: string) => renderUserCell(user, searchQuery);

  const columns: DTableProps<Role>['columns'] = [
    {
      title: t('roles.roles-list.name'),
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      render: (name: string) => (
        <CombinedText lines={1} text={name} highlight={searchQuery} />
      ),
    },
    {
      title: t('roles.roles-list.description'),
      dataIndex: 'description',
      key: 'description',
      sorter: true,
      render: (description: string) => (
        <CombinedText lines={1} text={description} highlight={searchQuery} />
      ),
      width: 310,
    },
    {
      title: t('roles.roles-list.users'),
      dataIndex: 'users',
      key: 'users',
      align: 'center',
      width: 100,
    },
    {
      title: t('roles.roles-list.processes'),
      dataIndex: 'process',
      key: 'process',
      align: 'center',
      width: 100,
    },
    {
      title: t('roles.roles-list.products'),
      dataIndex: 'products',
      key: 'products',
      align: 'center',
      width: 100,
    },
    {
      title: t('roles.roles-list.created-by'),
      dataIndex: 'createdBy',
      key: 'createdBy',
      sorter: true,
      render: renderUserCol,
    },
    {
      title: t('roles.roles-list.created-at'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: true,
      render: renderDateCell,
      align: 'center',
    },
    {
      title: t('roles.roles-list.last-modified-by'),
      dataIndex: 'updatedBy',
      key: 'lastModifiedBy',
      sorter: true,
      render: renderUserCol,
      width: 200,
    },
    {
      title: t('roles.roles-list.updated-at'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      sorter: true,
      render: renderDateCell,
      align: 'center',
      width: 220,
    },
    {
      dataIndex: 'actions',
      key: 'actions',
      fixed: 'right',
      align: 'center',
      render: (_, role) => (
        <ActionsDropdown item={role} getMenuItems={menuItems} />
      ),
      width: ACTIONS_COL_WIDTH,
    },
  ];

  return columns;
};
